import { useAccount } from 'wagmi'
import { useConnectModal } from '@rainbow-me/rainbowkit'

import { Button } from 'components/ui'

type Props = {
  text: string
  isLoading?: boolean
  loadingText?: string
  isDisabled?: boolean
  type: 'default' | 'outline'
  handleAction: VoidFunction
}

export function ActionButton({ type, text, loadingText, handleAction, isLoading, isDisabled }: Props) {
  const { isConnected } = useAccount()
  const { openConnectModal } = useConnectModal()

  return isConnected ? (
    <Button
      fullSize
      type={type}
      size='large'
      disabled={isDisabled}
      isLoading={isLoading}
      onClick={handleAction}
      loadingText={loadingText}
    >
      {text}
    </Button>
  ) : (
    <Button
      type={type}
      size='large'
      fullSize
      onClick={openConnectModal}
      isLoading={isLoading}
      loadingText='_connecting'
    >
      _connect-wallet
    </Button>
  )
}
